import { HubConnectionState } from "@microsoft/signalr";

export class HubConnectionShim {
  public Worker;
  public state = HubConnectionState.Disconnected;

  private _onCallbacks: Array<(...args: any[]) => void>;

  constructor(worker: Worker) {
    this.Worker = worker;
    this._onCallbacks = [];

    worker.onmessage = (event) => {
      if (event.data.type === "fetchState") {
        this.Worker.postMessage({
          type: "state",
          state: this.state,
        });
      }
    };
  }

  fetchState = () => {
    this.Worker.postMessage({
      type: "fetchState",
    });
  };

  onreconnected(callback: (connectionId?: string) => void) {
    this.state = HubConnectionState.Connected;
    this.Worker.postMessage({
      type: "onreconnected",
      payload: { callback },
    });
  }

  onreconnecting(callback: (error?: Error) => void) {
    this.state = HubConnectionState.Reconnecting;
    this.Worker.postMessage({
      type: "onreconnecting",
      payload: { callback },
    });
  }

  onclose(callback: (error?: Error) => void) {
    this.state = HubConnectionState.Disconnected;
    this.Worker.postMessage({
      type: "onclose",
      payload: { callback },
    });
  }

  start(): Promise<void> {
    this.Worker.postMessage({
      type: "start",
    });

    return new Promise((resolve) => {
      this.Worker.onmessage = (event) => {
        if (event.data.type === "started") {
          if (event.data.err) {
            throw event.data.err;
          }
          resolve();
        }
      };
    });
  }

  stop(): Promise<void> {
    this.Worker.postMessage({
      type: "stop",
    });

    return new Promise((resolve) => {
      this.Worker.onmessage = (event) => {
        if (event.data.type === "stopped") {
          if (event.data.err) {
            throw event.data.err;
          }
          resolve();
        }
      };
    });
  }

  on(methodName: string, method: (...args: any[]) => void) {
    this._onCallbacks.push(method);

    this.Worker.postMessage({
      type: "on",
      payload: { methodName },
    });
  }

  off(methodName: string, method: (...args: any[]) => void) {
    this._onCallbacks = this._onCallbacks.filter((cb) => cb !== method);
    // TODO: Unhook from events
  }

  invoke(methodName: string, ...args: any[]): Promise<void> {
    this.Worker.postMessage({
      type: "invoke",
      payload: { methodName, args },
    });

    return new Promise((resolve) => {
      this.Worker.onmessage = (event) => {
        if (event.data.type === "invoked") {
          if (event.data.err) {
            throw event.data.err;
          }
          resolve();
        }
      };
    });
  }
}
